"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fontanelice": {
    "0e61170f": [{
      "hkey": "d520e586",
      "slug": "gaggio",
      "name": "Gaggio",
      "primary": true,
      "skipSearch": false
    }],
    "gaggio-e-fornione": [{
      "hkey": "d520e586",
      "slug": "gaggio",
      "name": "Gaggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "35cfdfc6": [{
      "hkey": "c933f16b",
      "slug": "fontanelice",
      "name": "Fontanelice",
      "primary": true,
      "skipSearch": false
    }],
    "monte-in-pieve": [{
      "hkey": "c933f16b",
      "slug": "fontanelice",
      "name": "Fontanelice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "abac0e3e": [{
      "hkey": "c933f16b",
      "slug": "fontanelice",
      "name": "Fontanelice",
      "primary": true,
      "skipSearch": false
    }],
    "monte-morosino": [{
      "hkey": "c933f16b",
      "slug": "fontanelice",
      "name": "Fontanelice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c206999": [{
      "hkey": "c933f16b",
      "slug": "fontanelice",
      "name": "Fontanelice",
      "primary": true,
      "skipSearch": false
    }],
    "orsara": [{
      "hkey": "c933f16b",
      "slug": "fontanelice",
      "name": "Fontanelice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "53b1ca65": [{
      "hkey": "c933f16b",
      "slug": "fontanelice",
      "name": "Fontanelice",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-maddalena": [{
      "hkey": "c933f16b",
      "slug": "fontanelice",
      "name": "Fontanelice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;